import React, { useState } from "react";
import { erroricon, passwordshow, passwordhide } from "assets/icons/index";
import { Spin } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "redux/rootReducer";
import { useTranslation } from "react-i18next";
import { useResetPasswordFormik } from "Forms/ResetPassword/resetPasswordFormik";
// import { useResetPasswordFormik } from "forms/JoinUsForms/ResetPassword/resetPasswordFormik";

interface ResetPasswordProps {
  activePop: string;
  setActivePop: React.Dispatch<React.SetStateAction<string>>;
  email: any;
  phoneNum: any;
  resetPasswordMethod: any;
}

const ResetPassword = ({
  activePop,
  setActivePop,
  email,
  phoneNum,
  resetPasswordMethod,
}: ResetPasswordProps) => {
  const { t, i18n } = useTranslation();

  const formik = useResetPasswordFormik(
    setActivePop,
    resetPasswordMethod,
    phoneNum,
    email
  );

  const { resetPasswordLoading } = useSelector(
    (state: RootState) => state.resetPasswordReducer
  );

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  return (
    <section
      data-aos="zoom-out"
      data-aos-duration="400"
      className="fixed top-0 right-0 w-full h-screen bg-black/75 flex items-center justify-center z-10"
    >
      <div
        className={`relative lg:w-[410px] p-[30px] bg-white rounded-[15px] flex flex-col gap-[25px] text-second_color ${
          i18n.language === "en" ? "font-Poppins" : "font-Almarai"
        }`}
      >
        {/* Change Password section  */}
        <div className="relative flex items-center justify-between">
          <div></div>
          {/* Reset Password */}
          <div className="font-[700] text-[24px] text-second_color flex items-center justify-center">
            {t("Reset Password")}
            {/* enter your new password  */}
          </div>

          {/* close button */}
          {/* <div
            // onClick={() => setShowLogin(!showLogin)}
            className="cursor-pointer"
          >
            <img src={closeicon} alt="logo" />
          </div> */}
          <div></div>
        </div>

        {/* instructions */}
        <div className="font-[600] text-[14px] text-second_color flex items-center justify-center">
          {t("Great!, Now please enter your new password")}
        </div>

        {/* Phone number section  */}
        <form
          onSubmit={formik.handleSubmit}
          className="flex flex-col gap-[20px] text-white"
        >
          {/*  Password  */}
          <div className="flex flex-col gap-3">
            {/*  password  *********************************************/}
            <Spin spinning={resetPasswordLoading}>
              <div className="flex flex-col">
                <div className="relative">
                  <input
                    className={`w-full h-[48px] rounded-[15px] bg-[#DCDEE3] border-white border-[1px] focus:outline-none placeholder-black ${
                      i18n.language === "en" ? "pl-[15px]" : "pr-[15px]"
                    }`}
                    type={showPassword ? "text" : "password"}
                    placeholder={t("New Password")}
                    name="password"
                    onChange={formik.handleChange}
                  />

                  {/* show hide password  */}
                  {showPassword ? (
                    <div
                      onClick={() => setShowPassword(!showPassword)}
                      className={`absolute top-[35%] ${
                        i18n.language === "en" ? "right-[5%]" : "left-[5%]"
                      } cursor-pointer`}
                    >
                      <img src={passwordhide} alt="showPassword" />
                    </div>
                  ) : (
                    <div
                      onClick={() => setShowPassword(!showPassword)}
                      className={`absolute top-[35%] ${
                        i18n.language === "en" ? "right-[5%]" : "left-[5%]"
                      } cursor-pointer`}
                    >
                      <img src={passwordshow} alt="hidePassword" />
                    </div>
                  )}
                </div>
                {/* errors section  */}
                <div className="w-full flex items-center">
                  {formik.errors.password && (
                    <p className="text-red-700 font-Avenir_demi text-[14px] flex items-center gap-1 animate-pulse">
                      <img className="w-[22px]" src={erroricon} alt="" />{" "}
                      {formik.errors.password}
                    </p>
                  )}
                </div>
              </div>
            </Spin>

            {/* confirm password  **************************************/}
            <Spin spinning={resetPasswordLoading}>
              <div className="flex flex-col">
                <div className="relative">
                  <input
                    className={`w-full h-[48px] rounded-[15px] bg-[#DCDEE3] border-white border-[1px] focus:outline-none placeholder-black ${
                      i18n.language === "en" ? "pl-[15px]" : "pr-[15px]"
                    }`}
                    type={showConfirm ? "text" : "password"}
                    placeholder={t("Confirm Password")}
                    name="confirmPassword"
                    onChange={formik.handleChange}
                  />

                  {/* show hide password  */}
                  {showConfirm ? (
                    <div
                      onClick={() => setShowConfirm(!showConfirm)}
                      className={`absolute top-[35%] ${
                        i18n.language === "en" ? "right-[5%]" : "left-[5%]"
                      } cursor-pointer`}
                    >
                      <img src={passwordhide} alt="showPassword" />
                    </div>
                  ) : (
                    <div
                      onClick={() => setShowConfirm(!showConfirm)}
                      className={`absolute top-[35%] ${
                        i18n.language === "en" ? "right-[5%]" : "left-[5%]"
                      } cursor-pointer`}
                    >
                      <img src={passwordshow} alt="hidePassword" />
                    </div>
                  )}
                </div>
                {/* errors section  */}
                <div className="w-full flex items-center">
                  {formik.errors.confirmPassword && (
                    <p className="text-red-700 font-Avenir_demi text-[14px] flex items-center gap-1 animate-pulse">
                      <img className="w-[22px]" src={erroricon} alt="" />{" "}
                      {formik.errors.confirmPassword}
                    </p>
                  )}
                </div>
              </div>
            </Spin>
          </div>

          {/* Send Code button  */}
          <Spin spinning={resetPasswordLoading}>
            <button
              type="submit"
              className="w-full h-[40px] bg-[#DCDEE3] text-second_color text-[14px] font-[600] rounded-[15px] hover:text-white hover:bg-first_color duration-300"
            >
              {t("Confirm")}
            </button>
          </Spin>
        </form>
      </div>
    </section>
  );
};

export default ResetPassword;
